export default [
  {
    title: '小时',
    key: 'timeRange',
    fixed: true,
    width: 52
  },
  {
    title: '采集点击',
    key: 'collectClickNum',
    type: 'basic',
    width: 72
  },
  {
    title: '激活回调',
    key: 'callbackActive',
    type: 'basic',
    width: 72
  },
  {
    title: '注册回调',
    key: 'callbackRegister',
    type: 'basic',
    width: 72
  },
  {
    title: '付费回调',
    key: 'callbackPay',
    type: 'basic',
    width: 72
  },
  {
    title: '回调失败',
    key: 'callbackFail',
    type: 'basic',
    width: 72
  },
  {
    title: '激活',
    key: 'downNum',
    type: 'basic',
    width: 52
  },
  {
    title: '注册',
    key: 'newUserNum',
    type: 'basic',
    width: 52
  },
  {
    title: '创角',
    key: 'createRoleNum',
    type: 'basic',
    width: 52
  },
  {
    title: '新创角充值金额',
    key: 'newRoleMoney',
    type: 'basic',
    width: 92
  },
  {
    title: '付费用户数',
    key: 'payUserNum',
    type: 'basic',
    width: 80
  },
  {
    title: '付费金额',
    key: 'sumMoney',
    type: 'basic',
    width: 72
  }
]
